import { formatGP } from "@/lib/format";

export function gpColor(m, obo) {
  if (obo) return "#ff981f";
  if (m >= 10) return "#00ff80";
  if (m >= 0.1) return "#ffffff";
  return "#ffe83a";
}

function Coin({ size }) {
  return (
    <svg width={size} height={size} viewBox="0 0 16 16" aria-hidden="true" style={{ imageRendering: "pixelated" }} className="inline-block shrink-0">
      <circle cx="8" cy="8" r="7" fill="#d4a017" stroke="#000" strokeWidth="1.2" />
      <circle cx="8" cy="8" r="4.6" fill="#ffd84a" stroke="#a87400" strokeWidth="1" />
      <rect x="7" y="5" width="2" height="6" fill="#a87400" />
    </svg>
  );
}

export default function GP({ m, obo, className = "", coin = false, size = 22 }) {
  return (
    <span className={`font-rs font-bold rs-shadow inline-flex items-center gap-1.5 ${className}`} style={{ color: gpColor(m, obo) }}>
      {coin && !obo && <Coin size={size} />}
      {formatGP(m, obo)}
    </span>
  );
}
